
<Modal modalType="ImageUpload" mayCancel="true" v-on:cancel="onCancel">
  <h2>Upload Image or PDF</h2>
  <form class="PForm" enctype="multipart/form-data">
    <p>
      <input
        type="file"
        multiple
        accept="image/*, application/pdf"
        :disabled="uploadState === 'uploading'"
        @change="onChangeImageUpload"
      />
      <span v-if="uploadState === 'uploading'">Uploading…</span>
    </p>
    <p v-if="uploadState == 'failure'">{{ uploadError }}</p>
    <div class="ButtonRow-FlexSpaceBetween">
      <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
      <div></div>
      <!-- <button class="WBMBigButton m-primary">Upload</button> -->
    </div>
  </form>
</Modal>
